import { Button, Dialog, Flex, Heading, Text } from '@applyboard/crystal-ui'
import { Dispatch, SetStateAction, useState } from 'react'
import { useScreenResize } from '../../../hooks'
import { breakpoints } from '../../../utils'

interface PolicyBlockedDialogProps {
  showPolicyBlockedDialog: boolean
  setShowPolicyBlockedDialog: Dispatch<SetStateAction<boolean>>
  intakeTerm?: string
  onEditProgram: () => void
}

export function PolicyBlockedDialog({
  showPolicyBlockedDialog,
  setShowPolicyBlockedDialog,
  intakeTerm,
  onEditProgram,
}: PolicyBlockedDialogProps) {
  const [showModal, setShowModal] = useState(window.innerWidth >= breakpoints.sm)

  useScreenResize(() => {
    setShowModal(window.innerWidth >= breakpoints.sm)
  })

  if (!showPolicyBlockedDialog) {
    return null
  }

  const message = `This application cannot be submitted. The ${intakeTerm || 'intake'} application limit has been reached. Change the intake to be able to submit.`

  return (
    <>
      <Flex hideAbove="sm" direction="column" gap={10} grow={1}>
        <Heading level={1} variant="headlineL" align="center">
          Not able to submit
        </Heading>
        <Flex direction="column" gap={4} align="center">
          <Text>{message}</Text>
        </Flex>
        <Flex pt={1} direction="column" gap={4}>
          <Button
            onClick={() => {
              onEditProgram()
              setShowPolicyBlockedDialog(false)
            }}
            intent="primary"
            width="fill"
          >
            Change Intake
          </Button>
          <Button
            onClick={() => {
              setShowPolicyBlockedDialog(false)
            }}
            emphasis="highlighted"
            width="fill"
          >
            Cancel
          </Button>
        </Flex>
      </Flex>

      <Dialog
        open={showPolicyBlockedDialog && showModal}
        onOpenChange={setShowPolicyBlockedDialog}
        size="md"
      >
        <Dialog.Heading>Not able to submit</Dialog.Heading>
        <Dialog.Content>
          <Text>{message}</Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
          <Button
            onClick={() => {
              onEditProgram()
              setShowPolicyBlockedDialog(false)
            }}
            intent="primary"
            width="fill"
          >
            Change Intake
          </Button>
        </Dialog.Actions>
      </Dialog>
    </>
  )
}
